import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames/bind';
import Tooltip from 'yoda-checkout-components/lib/components/Tooltip/Tooltip';
import ToolTipIcon from 'yoda-checkout-components/lib/assets/svg/iconTooltipFilled.svg';
import {
    specialFinancingOfferTitle,
    specialFinancingOfferInformation,
} from 'yoda-checkout-components/lib/common/Constants';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import * as styles from './SpecialFinancingOfferInformation.css';

const cx = classNames.bind(styles);

function SpecialFinancingOfferInformation(props) {
    const specialFinancingOfferValue = props.financing.description;
    const offerValue = specialFinancingOfferValue
        ? specialFinancingOfferValue.replace(new RegExp('"', 'g'), '')
        : null;
    return (
        <div
            className={dt(['mt-4', 'smMd:pb-2'])}
            data-automation-id="at-special-finance-offer-wrapper"
        >
            {offerValue ? (
                <div
                    className={`${cx('col12', 'specialFinanceInformationWrapper')} ${dt([
                        '!m-0',
                        'sm:!p-0',
                    ])}`}
                >
                    <p
                        className={`${cx('financeHeader')} ${dt([
                            'text-black',
                            'font-open-sans-bold',
                            props.ocp ? 'text-normal' : 'text-small',
                            'inline-block',
                        ])}`}
                        data-automation-id="at-special-finance-offer-title"
                    >
                        {specialFinancingOfferTitle}
                    </p>
                    <div
                        className={`${dt([
                            'text-black',
                            'font-open-sans-regular',
                            'text-small',
                            'block',
                        ])} ${cx('financeInformation')}`}
                        data-automation-id="at-special-finance-offer-value"
                    >
                        <span className={dt(['mr-1.5'])}>{offerValue}</span>
                        <Tooltip
                            tooltipId="special-financing-tooltip"
                            tooltipMsg={specialFinancingOfferInformation}
                            theme={dt(['w-56'])}
                            place="bottom"
                            tooltipAutomationId="at-special-finance-offer-tooltip"
                            iconName="tooltip"
                            iconComponent={<ToolTipIcon />}
                            iconWidth="16px"
                        />
                    </div>
                </div>
            ) : (
                ''
            )}
        </div>
    );
}

SpecialFinancingOfferInformation.propTypes = {
    financing: PropTypes.objectOf(PropTypes.object),
    ocp: PropTypes.objectOf(PropTypes.bool),
};

SpecialFinancingOfferInformation.defaultProps = {
    financing: {},
    ocp: false,
};
export default SpecialFinancingOfferInformation;
